"use strict";
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { useState, useEffect, useRef, useCallback } from "react";
import { getGlobalConfig } from "../utils/getGlobalConfig";
export const useGooglePlacesPredictions = () => {
  const [predictions, setPredictions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [scriptLoaded, setScriptLoaded] = useState(false);
  const autocompleteService = useRef(null);
  const { googleApiKey } = getGlobalConfig();
  const fetchPredictions = (inputValue) => __async(void 0, null, function* () {
    if (!inputValue.trim() || !autocompleteService.current) {
      setPredictions([]);
      return;
    }
    setLoading(true);
    try {
      const request = {
        input: inputValue,
        types: ["geocode", "establishment"]
      };
      autocompleteService.current.getPlacePredictions(
        request,
        (results, status) => {
          setLoading(false);
          const isOk = status === google.maps.places.PlacesServiceStatus.OK && results;
          setPredictions(isOk ? results : []);
        }
      );
    } catch (error) {
      setPredictions([]);
    } finally {
      setLoading(false);
    }
  });
  const loadGoogleMapsScript = useCallback(() => {
    if (window.google && window.google.maps) {
      setScriptLoaded(true);
      autocompleteService.current = new google.maps.places.AutocompleteService();
      return;
    }
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${googleApiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = () => {
      setScriptLoaded(true);
      autocompleteService.current = new google.maps.places.AutocompleteService();
    };
    document.head.appendChild(script);
  }, [googleApiKey]);
  useEffect(() => {
    loadGoogleMapsScript();
  }, [loadGoogleMapsScript]);
  return {
    predictions,
    loading,
    scriptLoaded,
    fetchPredictions
  };
};
